import { ClubRequestForm } from "@/components/ClubRequestForm";

const STEPS = [
  { n: "01", t: "Tell us about your club", d: "Share your club, your city and how many members you expect. It takes two minutes." },
  { n: "02", t: "Pick a Saturday together", d: "Club Nights run six Saturdays a year. We'll find the one that works for your club." },
  { n: "03", t: "Toby comes to you", d: "Toby tells his story in person, then opens the floor to your members' questions." },
];

const CITIES = ["Tampa", "Phoenix", "Dallas", "Miami", "New Jersey"];
const PHOTOS = ["/images/bk/past-1.jpg", "/images/bk/past-2.jpg", "/images/bk/club-lounge.jpg", "/images/bk/past-3.jpg", "/images/bk/past-4.jpg"];

export default function ClubsPage() {
  return (
    <main data-testid="clubs-page">
      <section className="relative flex min-h-[460px] items-center overflow-hidden bg-[#141210]">
        <img src="/images/bk/club-hero.jpg" alt="" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(20,18,16,0.45),rgba(20,18,16,0.8))]" />
        <div className="relative mx-auto max-w-3xl px-5 py-20 text-center">
          <p className="reveal text-[11px] font-extrabold uppercase tracking-[0.25em] text-white/90">For bourbon clubs</p>
          <h1 className="reveal reveal-2 mt-5 font-display text-4xl leading-[1.08] text-white sm:text-5xl lg:text-6xl">Bring the Bourbon King <em className="block text-[#E8C878]">to your club.</em></h1>
          <p className="reveal reveal-3 mx-auto mt-6 max-w-xl text-white/90 md:text-lg">Six Saturdays a year, Toby takes his story on the road to bourbon clubs across the country.</p>
          <a href="#request" data-testid="clubs-hero-request-button" className="reveal reveal-4 mt-9 inline-block rounded border border-[#C9A24B] bg-[#141210]/80 px-8 py-4 text-xs font-extrabold uppercase tracking-[0.2em] text-[#F3DDA4] transition-colors hover:bg-[#C9A24B] hover:text-[#141210]">Request a Club Night</a>
        </div>
      </section>

      <section className="mx-auto max-w-6xl px-5 py-20 text-center sm:px-8" data-testid="clubs-steps">
        <h2 className="font-display text-3xl text-[#1F1B17] sm:text-4xl">How to book Toby</h2>
        <div className="mt-10 grid gap-4 text-left md:grid-cols-3">
          {STEPS.map((s) => (
            <div key={s.n} className="rounded-lg border border-[#E5DACA] bg-white p-6">
              <span className="font-display text-3xl text-[#C9A24B]">{s.n}</span>
              <h3 className="mt-2 font-display text-xl text-[#1F1B17]">{s.t}</h3>
              <p className="mt-2 text-sm leading-relaxed text-[#6B6157]">{s.d}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="bg-[#141210] py-16 text-center" data-testid="clubs-cities">
        <p className="eyebrow eyebrow-light">On the road</p>
        <div className="mx-auto mt-5 flex max-w-4xl flex-wrap justify-center gap-3 px-5">
          {CITIES.map((c) => <span key={c} className="rounded-full border border-[#C9A24B]/50 px-5 py-2 font-display text-lg text-white">{c}</span>)}
          <span className="rounded-full border border-dashed border-white/30 px-5 py-2 font-display text-lg text-[#BDB3A5]">Your city?</span>
        </div>
      </section>

      <section className="mx-auto max-w-6xl px-5 py-20 sm:px-8" data-testid="clubs-gallery">
        <h2 className="text-center font-display text-3xl text-[#1F1B17] sm:text-4xl">From past nights</h2>
        <div className="mt-10 grid grid-cols-2 gap-3 md:grid-cols-4">
          {PHOTOS.map((p, i) => (
            <img key={p} src={p} alt="Toby with guests at a past event" data-testid={`club-photo-${i}`}
              className={`h-full w-full rounded-lg object-cover transition-transform duration-500 hover:scale-[1.02] ${i === 0 ? "col-span-2 aspect-[4/3] md:row-span-2 md:aspect-square" : "aspect-square"}`} />
          ))}
        </div>
      </section>

      <section id="request" className="scroll-mt-24 bg-[#F1E9DA]" data-testid="clubs-request-section">
        <div className="mx-auto max-w-3xl px-5 py-20">
          <h2 className="text-center font-display text-3xl text-[#1F1B17] sm:text-4xl">Request a Club Night</h2>
          <p className="mb-10 mt-3 text-center text-[#6B6157]">Prefer to talk? Call <a href="tel:+15027830430" className="font-bold text-[#A8832F]" data-testid="clubs-phone-link">(502) 783-0430</a> or email <a href="mailto:bourbonkingevents@gmail.com" className="font-bold text-[#A8832F]" data-testid="clubs-email-link">bourbonkingevents@gmail.com</a>.</p>
          <ClubRequestForm />
        </div>
      </section>
    </main>
  );
}
